export default {
    title_list: 'Подписки пользователей',
    title_page: 'Подписка пользователя',
    title_create_page: 'Создать подписку пользователя',
    title_edit_page: 'Изменить подписку пользователя',

    filter: {
        labels: {
            plan_id: 'Тарифный план',
            parent_id: 'Родитель',
            user_id: 'Пользователь',
        }
    },

    table: {
        labels: {
            id: 'ID',
            plan_id: 'Тарифный план',
            parent_id: 'Родитель',
            user_id: 'Пользователь',
        }
    },

    buttons: {

    },

    form: {
        plan_id: 'Тарифный план',
        parent_id: 'Родитель',
        code: 'Промо-код',
        user_id: 'Пользователь',
        email: 'Email',
        from_name: 'Имя отправителя',
        to_name: 'Имя получателя',
        send_at: 'Дата отправки',
        occasion: 'Ассоциация',
        message: 'Сообщение',
        sender_notify: 'Уведомить отправителя',
    },
}
